<div class="ant-custom-grid">
  <nz-table
    #grid
    #rowSelectionTable
    (nzCurrentPageDataChange)="currentPageDataChange($event)"
    [nzData]="gridRowsData"
    [(nzScroll)]="gridSize"
    [nzBordered]="dataToUse.bordered"
    nzSize="middle"
    [nzFrontPagination]="isFrontPagination"
    [(nzPageIndex)]="pageIndex"
    [(nzPageSize)]="pageSize"
    (nzPageIndexChange)="onPaginationChange()"
    (nzPageSizeChange)="onPaginationChange()"
    [nzLoading]="loading"
    [nzLoadingIndicator]="loadSkeleton"
    nzShowSizeChanger
    [nzPageSizeOptions]="pageSizeOptions"
    [nzTotal]="total"
    [nzShowTotal]="dataToUse.showTotalCount ? rangeTemplate : ''"
  >
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }}-{{ range[1] }} of {{ total }} items
    </ng-template>
    <thead>
      <tr *ngFor="let colRow of columnsData">
        <th
          *ngIf="dataToUse.showCheckboxHeader == true"
          nzWidth="50px"
          nzShowCheckbox
          [(nzChecked)]="isAllDisplayDataChecked"
          [nzIndeterminate]="isIndeterminate"
          (nzCheckedChange)="checkAll($event)"
        ></th>
        <th
          *ngFor="let col of colRow; index as i"
          [nzShowSort]="col.showSort"
          [nzAlign]="'left'"
          [attr.colspan]="col.children"
          [nzSortFn]="undefined"
          [(nzSortOrder)]="mapOfSort[col.sortKey]"
          (nzSortOrderChange)="sort(col.sortKey, $event)"
          nzWidth="{{ dataToUse.widthConfig[i] }}"
        >
          <span>{{ col.header }}</span>
        </th>
      </tr>
      <tr *ngIf="dataToUse.showInternalFilters" class="filter-row">
        <td *ngIf="dataToUse.showCheckboxHeader == true" nzWidth="50px"></td>
        <td
          *ngFor="let col of columnsData[0]; index as i"
          [nzAlign]="'left'"
          class="column-filter"
        >
          <!-- filter rendrer -->
          <div *ngIf="col.showFilter" [ngSwitch]="col.filterType">
            <div *ngSwitchCase="'text'">
              <input
                type="text"
                [name]="col.sortKey"
                [(ngModel)]="col.currentValue"
                (change)="filterApplied($event, col)"
                class="text-filter"
              />
              <span class="text-filter-clear" (click)="resetFilter(col)">
                <va-icon size="small" name="close"></va-icon>
              </span>
            </div>
            <div class="column-filter" *ngSwitchCase="'select'">
              <nz-select
                [(ngModel)]="col.currentValue"
                nzSize="small"
                [nzDropdownClassName]="'select-filter'"
                (ngModelChange)="filterApplied($event, col)"
                style="font-size: 12px;"
              >
                <nz-option
                  *ngFor="let value of col.filterSelectValues"
                  [nzValue]="value.val"
                  [nzLabel]="value.display"
                ></nz-option>
              </nz-select>
            </div>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of gridRowsData">
        <td
          *ngIf="dataToUse.showCheckbox == true"
          nzShowCheckbox
          [(nzChecked)]="mapOfCheckedId[data.id]"
          (nzCheckedChange)="refreshStatus()"
          [nzDisabled]="data.selectionDisabled"
        ></td>
        <td *ngFor="let key of fields">
          <div [ngSwitch]="key.renderer" class="renderer">
            <app-date-renderer
              *ngSwitchCase="'date'"
              [dateValue]="data[key.field]"
            ></app-date-renderer>
            <app-link-renderer
              *ngSwitchCase="'link'"
              [linkObj]="data[key.field]"
              [docId]="data.id"
            ></app-link-renderer>
            <app-download-renderer
              [dataValue]="data[key.field]"
              [docId]="data.id"
              *ngSwitchCase="'download'"
            ></app-download-renderer>
            <app-print-renderer
              [dataValue]="data[key.field]"
              [docId]="data.id"
              *ngSwitchCase="'print'"
            ></app-print-renderer>
            <app-analyst-renderer
              [analysts]="data[key.field]"
              *ngSwitchCase="'analyst'"
            ></app-analyst-renderer>
            <app-icon-link-renderer
              *ngSwitchCase="'icon-link'"
              [linkObj]="data[key.field]"
            ></app-icon-link-renderer>
            <app-reporting-view-link-renderer
              *ngSwitchCase="'report-view-link'"
              [dataObj]="data[key.field]"
            ></app-reporting-view-link-renderer>
            <app-alert-grid-action-renderer
              *ngSwitchCase="'alert-grid-action'"
              [dataObj]="data[key.field]"
            ></app-alert-grid-action-renderer>
            <app-reporting-model-renderer
              *ngSwitchCase="'report-model-link'"
              [linkObj]="data[key.field]"
            ></app-reporting-model-renderer>
            <app-multi-icon-renderer
              *ngSwitchCase="'multi-icon'"
              [iconObjList]="data[key.field]"
            ></app-multi-icon-renderer>
            <app-checkbox-renderer
              *ngSwitchCase="'checkbox'"
              [dataObj]="data[key.field]"
            ></app-checkbox-renderer>
            <div *ngSwitchDefault>
              <div
                class="default-cell"
                *ngIf="
                  isReportingPage &&
                  data[key.field] &&
                  data[key.field].length > 20
                "
                title="{{ data[key.field] }}"
              >
                {{ data[key.field] }}
              </div>
              <div
                *ngIf="
                  isReportingPage &&
                  !(data[key.field] && data[key.field].length > 20)
                "
              >
                {{ data[key.field] }}
              </div>
              <div *ngIf="!isReportingPage">
                {{ data[key.field] }}
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <ng-template #loadSkeleton>
    <ng-template #indicatorTemplate>
      <va-icon
        [name]="faSpinner"
        isFontAwesome="true"
        spin="true"
        [styles]="{
          'font-size': '34px',
          'top': '50%',
          'left': '50%',
          'position': 'absolute'
        }"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </ng-template>
</div>
